/**
 * [sc-49176] Le Nature dell'IVA (tracciato FatturaPA 1.2, campo Natura): i
 * codici da indicare quando un'operazione non porta IVA, con il riferimento
 * normativo che li giustifica. Sono i codici che SdI accetta: un codice fuori
 * elenco fa scartare la fattura. Funzioni pure. Gemello di
 * `crmstart-api/src/config/nature.js`.
 */

export const NATURE = Object.freeze(
  [
    {
      codice: "N1",
      descrizione: "Escluse ex art. 15",
      riferimento: "Art. 15 DPR 633/72",
    },
    {
      codice: "N2.1",
      descrizione:
        "Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72",
      riferimento: "Artt. da 7 a 7-septies DPR 633/72",
    },
    {
      codice: "N2.2",
      descrizione: "Non soggette – altri casi",
      riferimento: "Operazione non soggetta ad IVA",
    },
    {
      codice: "N3.1",
      descrizione: "Non imponibili – esportazioni",
      riferimento: "Art. 8 c. 1 lett. a DPR 633/72",
    },
    {
      codice: "N3.2",
      descrizione: "Non imponibili – cessioni intracomunitarie",
      riferimento: "Art. 41 DL 331/93",
    },
    {
      codice: "N3.3",
      descrizione: "Non imponibili – cessioni verso San Marino",
      riferimento: "Art. 71 DPR 633/72",
    },
    {
      codice: "N3.4",
      descrizione:
        "Non imponibili – operazioni assimilate alle cessioni all'esportazione",
      riferimento: "Art. 8-bis DPR 633/72",
    },
    {
      codice: "N3.5",
      descrizione: "Non imponibili – a seguito di dichiarazioni d'intento",
      riferimento: "Art. 8 c. 1 lett. c DPR 633/72",
    },
    {
      codice: "N3.6",
      descrizione:
        "Non imponibili – altre operazioni che non concorrono alla formazione del plafond",
      riferimento: "Operazione non imponibile",
    },
    { codice: "N4", descrizione: "Esenti", riferimento: "Art. 10 DPR 633/72" },
    {
      codice: "N5",
      descrizione: "Regime del margine / IVA non esposta in fattura",
      riferimento: "Art. 36 DL 41/95",
    },
    {
      codice: "N6.1",
      descrizione:
        "Inversione contabile – cessione di rottami e altri materiali di recupero",
      riferimento: "Art. 74 c. 7 e 8 DPR 633/72",
    },
    {
      codice: "N6.2",
      descrizione: "Inversione contabile – cessione di oro e argento",
      riferimento: "Art. 17 c. 5 DPR 633/72",
    },
    {
      codice: "N6.3",
      descrizione: "Inversione contabile – subappalto nel settore edile",
      riferimento: "Art. 17 c. 6 lett. a DPR 633/72",
    },
    {
      codice: "N6.4",
      descrizione: "Inversione contabile – cessione di fabbricati",
      riferimento: "Art. 17 c. 6 lett. a-bis DPR 633/72",
    },
    {
      codice: "N6.5",
      descrizione: "Inversione contabile – cessione di telefoni cellulari",
      riferimento: "Art. 17 c. 6 lett. b DPR 633/72",
    },
    {
      codice: "N6.6",
      descrizione: "Inversione contabile – cessione di prodotti elettronici",
      riferimento: "Art. 17 c. 6 lett. c DPR 633/72",
    },
    {
      codice: "N6.7",
      descrizione:
        "Inversione contabile – prestazioni comparto edile e settori connessi",
      riferimento: "Art. 17 c. 6 lett. a-ter DPR 633/72",
    },
    {
      codice: "N6.8",
      descrizione: "Inversione contabile – operazioni settore energetico",
      riferimento: "Art. 17 c. 6 lett. d-bis, d-ter, d-quater DPR 633/72",
    },
    {
      codice: "N6.9",
      descrizione: "Inversione contabile – altri casi",
      riferimento: "Art. 17 DPR 633/72",
    },
    {
      codice: "N7",
      descrizione: "IVA assolta in altro Stato UE",
      riferimento: "Artt. 40 c. 3 e 4, 41 c. 1 lett. b DL 331/93",
    },
  ].map((n) => Object.freeze(n))
);

/** I codici che portano il bollo da 2 euro oltre la soglia (vincoli globali). */
export const NATURE_CON_BOLLO = Object.freeze([
  "N1",
  "N2.1",
  "N2.2",
  "N3.5",
  "N3.6",
  "N4",
]);

export const SOGLIA_BOLLO = 77.47;
export const IMPORTO_BOLLO = 2;

export function naturaValida(codice) {
  return NATURE.some((n) => n.codice === codice);
}

/** Il riferimento normativo proposto per il codice, o null se il codice non esiste. */
export function riferimentoPredefinito(codice) {
  return NATURE.find((n) => n.codice === codice)?.riferimento ?? null;
}

/** Come si legge l'IVA di una riga: l'aliquota, o la Natura se non c'è imposta. */
export function etichettaIva({ iva, natura }) {
  if (natura) return natura;
  return Number(iva) > 0 ? `${Number(iva)}%` : "Senza IVA";
}
